const initialState = {
  companies: [],
  selectedRows: [],
  initialFetchIsDone: false,
  loading: true,
  perPage: 20,
  page: 1,
  totalItems: 0,
  settings: {
    company: undefined,
    fetched: false,
  },
};

export default initialState;
